import {observable} from 'mobx';

class EmptyFormState {
  @observable question;

  receiveProps({question}) {
    this.question = question;

    this.question.args = {};
  }
}

export default EmptyFormState;
